/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type PreviewDirectoryRoleSetupSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type PreviewDirectoryRoleSetupRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type PreviewDirectoryRoleSetupSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const PreviewDirectoryRoleSetupSecurity$outboundSchema: z.ZodMiniType<
  PreviewDirectoryRoleSetupSecurity$Outbound,
  PreviewDirectoryRoleSetupSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function previewDirectoryRoleSetupSecurityToJSON(
  previewDirectoryRoleSetupSecurity: PreviewDirectoryRoleSetupSecurity,
): string {
  return JSON.stringify(
    PreviewDirectoryRoleSetupSecurity$outboundSchema.parse(
      previewDirectoryRoleSetupSecurity,
    ),
  );
}

/** @internal */
export type PreviewDirectoryRoleSetupRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const PreviewDirectoryRoleSetupRequest$outboundSchema: z.ZodMiniType<
  PreviewDirectoryRoleSetupRequest$Outbound,
  PreviewDirectoryRoleSetupRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function previewDirectoryRoleSetupRequestToJSON(
  previewDirectoryRoleSetupRequest: PreviewDirectoryRoleSetupRequest,
): string {
  return JSON.stringify(
    PreviewDirectoryRoleSetupRequest$outboundSchema.parse(
      previewDirectoryRoleSetupRequest,
    ),
  );
}
